import ContactRequests from './requests/ContactRequests';
import RegisterArtistRequests from './requests/RegisterArtistRequests';
import SiteRequest from './requests/SiteRequests';

export default {
	site: SiteRequest,
	contact: ContactRequests,
	registerArtist: RegisterArtistRequests,
};
